const openInPopout = (url, target = '') => {
  return window.open(
    url,
    target,
    `top=100,left=200,width=1030,height=500,noopener=${!target},noreferer=true`
  );
};

export default openInPopout;